import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_ERROR_TRUSTED_PARTY_ALREADY_ACTIVATED_TITLE,
	ONBOARDING_ERROR_TRUSTED_PARTY_ALREADY_ACTIVATED_DESCRIPTION,
	ONBOARDING_ERROR_START_WATCHING_CTA,
} from '../../../../constants/Copy';
import { useParams } from 'react-router';
import { ROUTE_HOME } from '../../../../constants/Routes';

const DefaultTrustedPartyAlreadyClaimed = (props) => {
	const { partnerName } = useParams();

	return (
		<FullPageMessage
			button={{
				onClick: () => props.history.push(ROUTE_HOME),
				testValue: ROUTE_HOME,
				text: ONBOARDING_ERROR_START_WATCHING_CTA,
			}}
			title={ONBOARDING_ERROR_TRUSTED_PARTY_ALREADY_ACTIVATED_TITLE.replace(
				'{trustedParty}',
				partnerName
			)}
			description={ONBOARDING_ERROR_TRUSTED_PARTY_ALREADY_ACTIVATED_DESCRIPTION.replace(
				'{trustedParty}',
				partnerName
			)}
		/>
	);
};

DefaultTrustedPartyAlreadyClaimed.propTypes = {
	history: PropTypes.object.isRequired,
};

export default DefaultTrustedPartyAlreadyClaimed;
